import axios from 'axios';
import { apiName } from '@/api/api.js'
let base = apiName;

//资产管理列表
export const requestZcglList = async params => {
    const res = await axios({ method: 'post', url: `${base}/zcgl/zcgllist`, params: params });
    return res.data;
};

//提交资产管理
export const requestZcglAdd = async params => {
    const res = await axios({ method: 'post', url: `${base}/zcgl/addzcgl`, params: params });
    return res.data;
};

//删除资产管理
export const requestZcglDel = async params => {
    const res = await axios({ method: 'post', url: `${base}/zcgl/zcgldel`, params: params });
    return res.data;
};

//资产管理详情
export const requestZcglDetails = async params => {
    const res = await axios({ method: 'post', url: `${base}/zcgl/zcgldetails`, params: params });
    return res.data;
};

//导出
export const requestDc = async params => {
    const res = await axios({ method: 'post', url: `${base}/zcgl/dc`, params: params });
    return res.data;
};

//获取对应单位列表
export const requestAllUser = async params => {
    const res = await axios({ method: 'post', url: `${base}/frame/getalluser`, params: params });
    return res.data;
};

//资产子表
export const requestZcSubjssj = async params => {
    const res = await axios({ method: 'post', url: `${base}/zcgl/jssj`, params: params });
    return res.data;
};
export const requestZcSubjssj1 = async params => {
    const res = await axios({ method: 'post', url: `${base}/zcgl/jssj1`, params: params });
    return res.data;
};